import { jsx as _jsx } from "preact/jsx-runtime";
// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from pointer-up.svg
 */
export default function PointerUpIcon(props) {
  return _jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "9",
    "data-component": "PointerUpIcon",
    ...props,
    children: _jsx("path", {
      stroke: "currentColor",
      d: "m.5 9 7-8 8 8"
    })
  });
}
//# sourceMappingURL=PointerUp.js.map